
import { CanonicalRule } from './types';

export const getDefaultCanonicalRules = (): CanonicalRule[] => [
  {
    path: '/nos-services/location-bennes/12',
    canonical: '/nos-services/location-bennes/aveyron',
    reason: 'Uniformisation nom vs numéro département'
  },
  {
    path: '/nos-services/location-bennes/31',
    canonical: '/nos-services/location-bennes/haute-garonne',
    reason: 'Uniformisation nom vs numéro département'
  },
  {
    path: '/nos-services/location-bennes/81',
    canonical: '/nos-services/location-bennes/tarn',
    reason: 'Uniformisation nom vs numéro département'
  },
  {
    path: '/services/pro',
    canonical: '/services/professionnels',
    reason: 'URL abrégée vers URL complète'
  },
  {
    path: '/services/collectivite',
    canonical: '/services/collectivites',
    reason: 'Pluriel standardisé'
  }
];
